import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import AboutView from "../views/AboutView.vue";
import PropertiesListView from "../views/PropertiesListView.vue";
import PropertiesItemView from "../views/PropertiesItemView.vue";
import TerrainsListView from "../views/TerrainsListView.vue";
import SearchListView from "../views/SearchListView.vue";
import PropertyRegisterView from "../views/PropertyRegisterView.vue";
import PropertyRegisterResponseView from "../views/PropertyRegisterResponseView.vue";
// import ListCustomView from "../views/ListCustomView.vue";
// import ArticleCustomView from "../views/ArticleCustomView.vue";
// import NewsCard from "../components/cards/NewsCard.vue";
import ContactView from "../views/ContactView.vue";
import ContactResponseView from "../views/ContactResponseView.vue";
import PolicyPrivacyView from "../views/PolicyPrivacyView.vue";
import Error404View from "../views/Error404View.vue";

Vue.use(VueRouter);

const routes = [
  {
    name: "",
    path: "/",
    component: HomeView,
  },
  {
    name: "Sobre",
    path: "/sobre",
    component: AboutView,
  },
  {
    name: "Imóveis a Venda",
    path: "/imoveis",
    component: PropertiesListView,
  },
  {
    name: "Imóveis para Locação",
    path: "/locacao",
    component: PropertiesListView,
  },
  {
    name: "Imóvel para Locação",
    path: "/locacao/:item",
    component: PropertiesItemView,
  },
  {
    name: "Imóveis",
    path: "/rural",
    component: PropertiesListView,
  },
  {
    name: "Imóvel",
    path: "/rural/:item",
    component: PropertiesItemView,
  },
  {
    name: "Imóvel a Venda",
    path: "/imoveis/:item",
    component: PropertiesItemView,
  },
  {
    name: "Terrenos",
    path: "/terrenos",
    component: TerrainsListView,
  },
  {
    name: "Terreno",
    path: "/terrenos/:item",
    component: PropertiesItemView,
  },
  {
    name: "Busca",
    path: "/busca",
    component: SearchListView,
  },
  {
    name: "Cadastre seu Imóvel",
    path: "/cadastre-seu-imovel",
    component: PropertyRegisterView,
  },
  {
    name: "Cadastre seu Imóvel",
    path: "/cadastre-seu-imovel/obrigado",
    component: PropertyRegisterResponseView,
  },
  {
    name: "Fale Conosco",
    path: "/fale-conosco",
    component: ContactView,
  },
  {
    name: "Obrigado!",
    path: "/fale-conosco/obrigado",
    component: ContactResponseView,
  },
  {
    name: "Política de Privacidade",
    path: "/politica-de-privacidade",
    component: PolicyPrivacyView,
  },
  {
    path: "/erro404",
    name: "Erro 404",
    component: Error404View,
  },
  {
    path: "*",
    component: Error404View,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
      };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes,
});

export default router;
